import React, { useEffect, useState } from "react";
// import UsersList from "./UsersList";
import DepenseSchema from "./DepenseSchema";
import Files from "./Files";
import Select from "react-select";


const Etape2 = ({
  renderError,
  formData,
  handleChange,
  setFormData,
  isReadOnly,
  page,
}) => {
  const [funds, setFunds] = useState([]);
  const [centreCouts, setCentreCout] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/Funds`)
      .then((response) => response.json())
      .then((data) => setFunds(data))
      .catch((error) => console.error("Error fetching funds:", error));
    fetch(`${process.env.REACT_APP_API_BASE_URL}/CentreCout`)
      .then((response) => response.json())
      .then((data) => setCentreCout(data))
      .catch((error) => console.error("Error fetching CentreCout:", error));
  }, []);

  // Recalculer 'montantVisaConseil' quand 'depenses' change
  useEffect(() => {
    const newMontantVisaConseil = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Visa du Conseil")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      visaConseil: {
        ...prevFormData.visaConseil,
        montantTotalDepensesVisa: parseFloat(newMontantVisaConseil.toFixed(2)),
      },
    }));
  }, [formData.depenses, setFormData]);

  /************************************************************************/

  return (
    <div className=" p-4 ">
      {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Information générale
        </h1> */}
      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="numeroFormulaire"
            className="block text-sm font-medium text-blue-900"
          >
            Numéro de formulaire:
          </label>
          <input
            type="text"
            id="numeroFormulaire"
            name="numeroFormulaire"
            value={formData.numeroFormulaire}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          
        </div>
      </div>

      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="dateEntreeEnVigueur"
            className="block text-sm font-medium text-blue-900"
          >
            Date :
          </label>
          <input
            type="date"
            id="dateSoumission"
            name="dateSoumission"
            value={formData.dateSoumission?.split("T")[0] ?? ""}
            onChange={handleChange}
            required
            disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          
        </div>
      </div>

      <div className="w-full flex justify-center mt-6 mb-20">
  <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
    <p className="text-md font-bold flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Réclamation mensuelle de dépenses d'emploi
    </p>
  </div>
</div>

      <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-red-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8c-1.657 0-3 1.343-3 3 0 2.667 3 4 3 4s3-1.333 3-4c0-1.657-1.343-3-3-3zM12 2a10 10 0 100 20 10 10 0 000-20z"
      />
    </svg>
    Compte budgétaire
  </p>
</div>

      <p className="mt-10 mtext-md ">
        Veuillez inscrire votre compte budgétaire par défaut.
      </p>

      <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5 ">
          <label
            htmlFor="funds"
            className="mb-1 block text-sm font-medium text-blue-900"
          >
            Fonds :
          </label>
          {/* <select
            id="funds"
            name="funds"
            value={formData.funds}
            onChange={handleChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            disabled={isReadOnly}
          >
            <option value="">Selectionner</option>
            {funds.map((fund) => (
              <option key={fund._id} value={fund.value}>
                {fund.value}
              </option>
            ))}
          </select> */}

          <Select
            id="funds"
            name="funds"
            options={funds.map((fund) => ({
              value: fund.value,
              label: String(fund.value),
            }))}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "funds",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            placeholder="Sélectionner"
            value={
              formData.funds
                ? { value: formData.funds, label: String(formData.funds) }
                : null
            }
            isClearable
            menuPlacement="auto"
            className="react-select-container"
            classNamePrefix="react-select"
            filterOption={(option, inputValue) =>
              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
            }
            isDisabled={isReadOnly}
          />
          {/* {renderError("funds")} */}
        </div>
        <div className="w-3/5 ">
          <label
            htmlFor="centreCout"
            className="block text-sm font-medium text-blue-900"
          >
            Centre de coût :
          </label>
          {/* <select
            id="centreCout"
            name="centreCout"
            value={formData.centreCout}
            onChange={handleChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            disabled={isReadOnly}
          >
            <option value="">Selectionner</option>
            {centreCouts.map((centreCout) => (
              <option key={centreCout._id} value={centreCout.value}>
                {centreCout.value}
              </option>
            ))}
          </select> */}
          <Select
            id="centreCout"
            name="centreCout"
            options={centreCouts.map((centreCout) => ({
              value: centreCout.value,
              label: String(centreCout.value),
            }))}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "centreCout",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            placeholder="Sélectionner"
            value={
              formData.centreCout
                ? {
                    value: formData.centreCout,
                    label: String(formData.centreCout),
                  }
                : null
            }
            isClearable
            menuPlacement="auto"
            className="react-select-container"
            classNamePrefix="react-select"
            filterOption={(option, inputValue) =>
              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
            }
            isDisabled={isReadOnly}
          />
          {/* {renderError("centreCout")} */}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
        <div className="w-3/5">
          <label
            htmlFor="adresse"
            className="block text-sm font-medium text-blue-900"
          >
            Ordre (optionnel) :
          </label>
          <input
            type="text" // switched to text for better control
            id="ordre"
            name="ordre"
            maxLength={6} // limit length
            value={formData.ordre}
            onChange={(e) => {
        const val = e.target.value;
        if (/^\d*$/.test(val)) {
          handleChange(e);
        }
      }}
      onKeyDown={(e) => {
    // Autoriser uniquement les touches numériques, backspace, delete, flèches
    if (
      !(
        (e.key >= '0' && e.key <= '9') ||
        e.key === 'Backspace' ||
        e.key === 'Delete' ||
        e.key === 'ArrowLeft' ||
        e.key === 'ArrowRight' ||
        e.key === 'Tab'
      )
    ) {
      e.preventDefault();
    }
  }}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            readOnly={isReadOnly}
          />
        </div>
      </div>

      <div className="mt-[6%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-purple-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8c-1.657 0-3 1.343-3 3 0 2.667 3 4 3 4s3-1.333 3-4c0-1.657-1.343-3-3-3zM12 2a10 10 0 100 20 10 10 0 000-20z"
      />
    </svg>
    Dépenses
  </p>
</div>


      <DepenseSchema
        renderError={renderError}
        formData={formData}
        handleChange={handleChange}
        setFormData={setFormData}
        funds={funds}
        centreCouts={centreCouts}
        isReadOnly={isReadOnly}
        page={page}
      />

      {/* {((formData.depenses.some(depense =>
          depense.rows.some(row => row.typeDepenses === "Visa du Conseil")
        )) || 
        (formData.achatsCarteCréditProfessionnelle === "oui") )&& ( */}

      {formData.achatsCarteCréditProfessionnelle &&
        formData.achatsCarteCréditProfessionnelle === "oui" && (
          <div>
            <div className="mt-[5%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-indigo-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7M12 20c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z"
      />
    </svg>
    Visa du Conseil
  </p>
</div>


            <div className="mt-8 w-3/4 grid grid-cols-2  gap-0">
              <div className="w-3/5">
                <label
                  htmlFor="montantTotalReleveVisa"
                  className="block text-sm font-medium text-blue-900"
                >
                  Inscrire le montant total selon le relevé de Visa{" "}
                  <span className="text-xl text-red-900">*</span> :
                </label>
                <div className="relative">
                  <input
                    type="text"
                    step="0.01"
                    id="montantTotalReleveVisa"
                    name="montantTotalReleveVisa"
                    value={formData.visaConseil.montantTotalReleveVisa ?? ""}
                    // onChange={handleChange}
                    onChange={(e) => {
                      // On normalise aussi à la saisie (remplace la virgule par un point)
                      handleChange({
                        target: {
                          name: "montantTotalReleveVisa",
                          value: e.target.value.replace(',', '.'),
                        },
                      });
                    }}
                        onKeyDown={(e) => {
                          // Autoriser uniquement les touches numériques, backspace, delete, flèches
                          if (
                              !(
                                (e.key >= '0' && e.key <= '9') ||
                                e.key === ',' ||
                                e.key === '.' ||
                                e.key === '-' ||
                                e.key === 'Backspace' ||
                                e.key === 'Delete' ||
                                e.key === 'ArrowLeft' ||
                                e.key === 'ArrowRight' ||
                                e.key === 'Tab'
                              )
                          ) {
                            e.preventDefault();
                          }
                        }}
                    // onBlur={(e) => {
                    //   const value = parseFloat(e.target.value || 0).toFixed(2);
                    //   handleChange({
                    //     target: {
                    //       name: "montantTotalReleveVisa",
                    //       value,
                    //     },
                    //   });
                    // }}
                    onBlur={(e) => {
                      const rawValue = e.target.value.replace(',', '.'); // conversion
                      const value = parseFloat(rawValue || 0).toFixed(2);

                      handleChange({
                        target: {
                          name: "montantTotalReleveVisa",
                          value,
                        },
                      });
                    }}
                    required
                    readOnly={
                      isReadOnly &&
                      !(
                        page === "Mes taches" &&
                        formData.etatDemande === "En traitement"
                      )
                    }
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  />
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
                </div>


                {renderError("montantTotalReleveVisa")}
              </div>

              <div className="w-3/5">
                <label
                  htmlFor="montantTotalDepensesVisa"
                  className="block text-sm font-medium text-blue-900"
                >
                  Montant total des dépenses Visa :
                </label>
                <div className="relative">
  <input
    type="text"
    id="montantTotalDepensesVisa"
    name="montantTotalDepensesVisa"
    value={
      formData.visaConseil.montantTotalDepensesVisa !== null &&
      formData.visaConseil.montantTotalDepensesVisa !== undefined
        ? parseFloat(formData.visaConseil.montantTotalDepensesVisa).toFixed(2)
        : ""
    }
    disabled
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>

                
              </div>
              <Files
                renderError={renderError}
                formData={formData}
                setFormData={setFormData}
                section="Visa du Conseil"
                isReadOnly={isReadOnly}
              />
            </div>
          </div>
        )}

      {formData.depensesEtrReclamer &&
        formData.depensesEtrReclamer === "oui" && (
          <div>
            <div className="mt-[5%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-orange-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 10h18M3 14h18M5 6h14M5 18h14"
      />
    </svg>
    407 ETR
  </p>
</div>


            <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
              <Files
                renderError={renderError}
                formData={formData}
                setFormData={setFormData}
                section="407 ETR"
                isReadOnly={isReadOnly}
              />
            </div>
          </div>
        )}

      {formData.depensesActiviteExterne &&
        formData.depensesActiviteExterne === "oui" && (
          <div>
            <div className="mt-[5%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-teal-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 14l9-5-9-5-9 5 9 5zm0 0v6m0-6L3 9m9 5l9-5"
      />
    </svg>
    Formation
  </p>
</div>

            <div className="mt-8 w-3/4 grid grid-cols-2  gap-0">
              <div className="w-3/5">
                <label
                  htmlFor="dateFormation"
                  className="block text-sm font-medium text-blue-900"
                >
                  Date <span className="text-xl text-red-900">*</span> :
                </label>
                <input
                  type="date"
                  id="dateFormation"
                  name="dateFormation"
                  value={formData.formation.dateFormation}
                  onChange={handleChange}
                  required
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  readOnly={isReadOnly}
                />
                {renderError("dateFormation")}
              </div>

              <div className="w-3/5">
                <label
                  htmlFor="nomFormation"
                  className="block text-sm font-medium text-blue-900"
                >
                  Nom de la formation, colloque ou activité externe{" "}
                  <span className="text-xl text-red-900">*</span> :
                </label>
                <input
                  type="text"
                  id="nomFormation"
                  name="nomFormation"
                  value={formData.formation.nomFormation}
                  onChange={handleChange}
                  required
                  // disabled
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  readOnly={isReadOnly}
                />
                {renderError("nomFormation")}
              </div>
            </div>

            <div className="mt-8 w-3/4 grid grid-cols-2  gap-0">
              <div className="w-3/5 mt-4">
                <label
                  htmlFor="commentaireFormation"
                  className="block text-sm font-medium text-blue-900"
                >
                  Commentaires :
                </label>

                <textarea
                  placeholder="Ajoutez un commentaire..."
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  rows="3"
                  id="commentaireFormation"
                  name="commentaireFormation"
                  value={formData.formation.commentaireFormation}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                />
                {/* {renderError("commentaireFormation")} */}
              </div>

              <Files
                renderError={renderError}
                formData={formData}
                setFormData={setFormData}
                section="formation"
                isReadOnly={isReadOnly}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default Etape2;
